// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".empty-text-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n}\n.empty-text-wrap .empty-txt {\n  margin-top: 12px;\n  color: #A4A4A4;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 150%; /* 21px */\n  letter-spacing: -0.28px;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
